import { render } from "./UserAvatarComponent.vue?vue&type=template&id=b48032f8"
import script from "./UserAvatarComponent.vue?vue&type=script&lang=js"
export * from "./UserAvatarComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__